module.exports = __webpack_public_path__ + "img/android.a6bb8bb3.svg";